module.exports = __webpack_public_path__ + "static/media/paju.7bb9de1b.png";